var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "bundle-product-form uk-form-stacked",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.submit($event)
      }
    }
  }, [_c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v(_vm._s(_vm.$t('fieldsets.basicFields')))]), _vm._v(" "), _c('product-family-combobox', {
    attrs: {
      "label": _vm.$t('fields.family'),
      "errors": _vm.fields.errors.family,
      "disabled": !_vm.isEditable,
      "filter": {
        bundle: true
      }
    },
    model: {
      value: (_vm.fields.values.family),
      callback: function($$v) {
        _vm.fields.values.family = $$v
      },
      expression: "fields.values.family"
    }
  }), _vm._v(" "), _c('text-input', {
    ref: "nameInput",
    attrs: {
      "type": "text",
      "label": _vm.$t('fields.name'),
      "errors": _vm.fields.errors.name,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.name),
      callback: function($$v) {
        _vm.fields.values.name = $$v
      },
      expression: "fields.values.name"
    }
  }), _vm._v(" "), _c('text-input', {
    attrs: {
      "type": "text",
      "label": _vm.$t('fields.articleNumber'),
      "errors": _vm.fields.errors.articleNumber,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.articleNumber),
      callback: function($$v) {
        _vm.fields.values.articleNumber = $$v
      },
      expression: "fields.values.articleNumber"
    }
  }), _vm._v(" "), _c('keyword-list-input', {
    attrs: {
      "label": _vm.$t('fields.tags'),
      "errors": _vm.fields.errors.tags,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.tags),
      callback: function($$v) {
        _vm.fields.values.tags = $$v
      },
      expression: "fields.values.tags"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('fieldsets.bundledProducts')) + "\n    ")]), _vm._v(" "), (_vm.fields.values.family) ? _c('div', {
    staticClass: "uk-margin"
  }, [(_vm.bundleDefinitionsLoading) ? _c('loader', [_vm._v("\n        " + _vm._s(_vm.$t('loaders.bundledProducts')) + "\n      ")]) : _c('div', [(_vm.bundleDefinitions.length) ? _vm._l((_vm.bundleDefinitions), function(definition, index) {
    return (_vm.fields.values.bundlings[index]) ? _c('div', [_c('product-combobox', {
      attrs: {
        "label": definition.productFamily.name,
        "errors": _vm.fields.errors.bundlings[index] && _vm.fields.errors.bundlings[index].product,
        "disabled": !_vm.isEditable,
        "filter": {
          bundle: false,
          familyId: definition.productFamily.id
        }
      },
      model: {
        value: (_vm.fields.values.bundlings[index].product),
        callback: function($$v) {
          _vm.fields.values.bundlings[index].product = $$v
        },
        expression: "fields.values.bundlings[index].product"
      }
    })], 1) : _vm._e()
  }) : _c('alert-box', {
    attrs: {
      "type": "warning",
      "icon": "warning"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('hints.missingBundleDefinitions')) + "\n          "), _c('br'), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'product-family',
        params: {
          id: _vm.fields.values.family.id
        }
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$t('actions.solveIssue')) + "\n          ")])], 1)], 2)], 1) : _c('alert-box', {
    attrs: {
      "icon": "info"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('prompts.selectFamily')) + "\n    ")])], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('fieldsets.details')) + "\n    ")]), _vm._v(" "), _c('text-input', {
    attrs: {
      "type": "text",
      "label": _vm.$t('fields.altName'),
      "errors": _vm.fields.errors.altName,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.altName),
      callback: function($$v) {
        _vm.fields.values.altName = $$v
      },
      expression: "fields.values.altName"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "label": _vm.$t('fields.shortUsp'),
      "errors": _vm.fields.errors.shortUsp,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.shortUsp),
      callback: function($$v) {
        _vm.fields.values.shortUsp = $$v
      },
      expression: "fields.values.shortUsp"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "label": _vm.$t('fields.usps'),
      "errors": _vm.fields.errors.usps,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.usps),
      callback: function($$v) {
        _vm.fields.values.usps = $$v
      },
      expression: "fields.values.usps"
    }
  }), _vm._v(" "), _c('text-list-input', {
    attrs: {
      "label": _vm.$t('fields.summaryTexts'),
      "errors": _vm.fields.errors.summaryTexts,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.summaryTexts),
      callback: function($$v) {
        _vm.fields.values.summaryTexts = $$v
      },
      expression: "fields.values.summaryTexts"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('fieldsets.seo')) + "\n    ")]), _vm._v(" "), _c('text-input', {
    attrs: {
      "type": "text",
      "label": _vm.$t('fields.slug'),
      "errors": _vm.fields.errors.slug,
      "disabled": !_vm.isEditable,
      "placeholder": _vm.slugPlaceholder
    },
    model: {
      value: (_vm.fields.values.slug),
      callback: function($$v) {
        _vm.fields.values.slug = $$v
      },
      expression: "fields.values.slug"
    }
  }), _vm._v(" "), _c('textarea-input', {
    attrs: {
      "label": _vm.$t('fields.description'),
      "errors": _vm.fields.errors.description,
      "disabled": !_vm.isEditable,
      "rows": "5"
    },
    model: {
      value: (_vm.fields.values.description),
      callback: function($$v) {
        _vm.fields.values.description = $$v
      },
      expression: "fields.values.description"
    }
  }), _vm._v(" "), _c('keyword-list-input', {
    attrs: {
      "label": _vm.$t('fields.aliases'),
      "errors": _vm.fields.errors.aliases,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.aliases),
      callback: function($$v) {
        _vm.fields.values.aliases = $$v
      },
      expression: "fields.values.aliases"
    }
  }), _vm._v(" "), _c('keyword-list-input', {
    attrs: {
      "label": _vm.$t('fields.keywords'),
      "errors": _vm.fields.errors.keywords,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.keywords),
      callback: function($$v) {
        _vm.fields.values.keywords = $$v
      },
      expression: "fields.values.keywords"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('fieldsets.legalTexts')) + "\n    ")]), _vm._v(" "), _c('legal-text-manager', {
    attrs: {
      "errors": _vm.fields.errors.legalTexts,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.legalTexts),
      callback: function($$v) {
        _vm.fields.values.legalTexts = $$v
      },
      expression: "fields.values.legalTexts"
    }
  })], 1), _vm._v(" "), _c('fieldset', {
    staticClass: "uk-fieldset uk-margin-medium-top"
  }, [_c('legend', {
    staticClass: "uk-legend uk-margin"
  }, [_vm._v("\n      " + _vm._s(_vm.$t('fieldsets.media')) + "\n    ")]), _vm._v(" "), _c('attachment-manager', {
    attrs: {
      "attachment-type": "MEDIA_OBJECT",
      "errors": _vm.fields.errors.media,
      "disabled": !_vm.isEditable
    },
    model: {
      value: (_vm.fields.values.media),
      callback: function($$v) {
        _vm.fields.values.media = $$v
      },
      expression: "fields.values.media"
    }
  })], 1), _vm._v(" "), _c('Checkbox', {
    attrs: {
      "label": 'Always Displayed?'
    },
    model: {
      value: (_vm.fields.values.alwaysDisplayed),
      callback: function($$v) {
        _vm.fields.values.alwaysDisplayed = $$v
      },
      expression: "fields.values.alwaysDisplayed"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "uk-margin-medium-top"
  }, [_c('submit-button', {
    attrs: {
      "type": "primary",
      "disabled": !_vm.isSubmittable
    }
  }), _vm._v(" "), _c('cancel-button')], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c27c6f4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/BundleProductForm.vue
// module id = 1941
// module chunks = 0